import React, { useEffect, useState, useCallback } from 'react';
import { apiFetch } from '../utils/apiClient';
import ArchivesSchema from '../components/ArchivesSchema';

const ArchivesForms = ({ user, checkGroupAdmin, checkGroupRecMensuelle,checkGroupInfoBancaire,checkGroupDecAnnuelle}) => {
  const [userId, setuserId] = useState('');
  const [selectedForm, setSelectedForm] = useState('');
  const [selectedEtat, setSelectedEtat] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [numeroFormulaire, setNumeroFormulaire] = useState('');
  const [filterNom, setFilterNom] = useState('');
  const [showFilters, setShowFilters] = useState(true);
  const [sortedData, setSortedData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [authLoading, setAuthLoading] = useState(true);
  const [messageErreur, setMessageErreur] = useState('');
  const [messageErreurNom, setMessageErreurNom] = useState('');
 const [messageErreurDate, setMessageErreurDate] = useState('');

  useEffect(() => {
    if (user) setuserId(user.id);
  }, [user]);

  const fetchData = useCallback(async (customFilters = {}) => {
    if (!userId) return;

    const queryParams = new URLSearchParams({
      userId,
      checkGroupAdmin,
      checkGroupRecMensuelle,
      checkGroupInfoBancaire,
      checkGroupDecAnnuelle,
      ...(customFilters.startDate ? { startDate: customFilters.startDate } : {}),
      ...(customFilters.endDate ? { endDate: customFilters.endDate } : {}),
      ...(customFilters.numeroFormulaire ? { numeroFormulaire: customFilters.numeroFormulaire } : {}),
      ...(customFilters.filterNom ? { filterNom: customFilters.filterNom } : {}),
    });

    try {
      setAuthLoading(true);
      const response = await apiFetch(
        `${process.env.REACT_APP_API_BASE_URL}/archives?${queryParams.toString()}`
      );
      if (!response.ok) throw new Error('Erreur lors de la récupération des données.');

      const data = await response.json();
      setSortedData(data);
    } catch (error) {
      console.error('Erreur :', error);
    } finally {
      setAuthLoading(false);
    }
  }, [userId, checkGroupAdmin, checkGroupRecMensuelle,checkGroupInfoBancaire,checkGroupDecAnnuelle]);

  // ✅ Premier rendu uniquement
  useEffect(() => {
    if (userId) fetchData();
  }, [userId, fetchData]);

  const handleSearch = () => {
    setMessageErreur("")
    setMessageErreurNom("")
    setMessageErreurDate("")
   if ((!startDate && endDate)) {
      setMessageErreurDate("Veuillez renseigner à la fois la date de début et la date de fin.");
      return;
    }

    const start = new Date(startDate);
    const end = endDate ? new Date(endDate) : new Date();

    // Vérifier que la date de fin est après la date de début
    if (end < start) {
      setMessageErreurDate("La date de fin doit être postérieure à la date de début.");
      return;
    }

    // Calcul de la différence en mois
    const diffMonths =
      (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());

    // Vérifier que la période ne dépasse pas 6 mois
    if (!(filterNom || numeroFormulaire) && (diffMonths > 6 || (diffMonths === 6 && end.getDate() > start.getDate()))) {
      setMessageErreurDate("La période entre les deux dates ne doit pas dépasser 6 mois.");
      return;
    }

    if (filterNom && filterNom.length < 3) {
      setMessageErreurNom("Le nom doit contenir au moins 4 caractères pour effectuer la recherche.");
      return;
    }
    // Vérifier que filterValue contient au moins 4 chiffres
    if (numeroFormulaire && numeroFormulaire.replace(/\D/g, '').length < 4) {
      setMessageErreur("La valeur doit contenir au moins 4 chiffres pour effectuer la recherche.");
      return;
    }
    setCurrentPage(1);
  // ✅ Tout est OK → lancer la recherche
  fetchData({ startDate, endDate, numeroFormulaire, filterNom });
};

  const handleClearFilters = () => {
    setMessageErreur("")
    setMessageErreurNom("")
    setMessageErreurDate("")
    setSelectedForm('');
    setSelectedEtat('');
    setNumeroFormulaire('');
    setFilterNom('');
    setStartDate('');
    setEndDate('');
    setCurrentPage(1);
    setSortedData([]);
    // ✅ Recharge toutes les données initiales
    fetchData();
  };

  const filteredData = Array.isArray(sortedData)
    ? sortedData.filter((item) => {
        const matchesForm = selectedForm ? item.formulaire === selectedForm : true;
        const matchesEtat = selectedEtat ? item.etatDemande === selectedEtat : true;
        return matchesForm && matchesEtat;
      })
    : [];

  return (
    <div className="min-h-screen p-4">
      <button
        onClick={() => setShowFilters(!showFilters)}
        className="bg-blue-500 hover:bg-blue-600 text-white font-semibold mb-4 px-2 py-2 rounded-xl shadow-md transition-all duration-200"
      >
        {showFilters ? 'Masquer les filtres' : 'Afficher les filtres'}
      </button>

      {showFilters && (
        <div className="flex flex-wrap gap-4 mb-6 bg-white p-6 rounded-2xl shadow-lg border border-gray-200 transition-all duration-300">
          {checkGroupAdmin && (
            <div className="flex flex-col">
              <label htmlFor="formFilter" className="mb-1 text-md font-semibold text-gray-700">
                Formulaire
              </label>
              <select
                id="formFilter"
                value={selectedForm}
                onChange={(e) => setSelectedForm(e.target.value)}
                className="p-3 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200"
              >
                <option value="">Tous les formulaires</option>
                <option value="Changement information bancaire">Changement information bancaire</option>
                <option value="Déclaration annuelle">Déclaration annuelle</option>
                <option value="Réclamation mensuelle de dépenses">Réclamation mensuelle de dépenses</option>
              </select>
            </div>
          )}

          <div className="flex flex-col  w-[14%]">
            <label htmlFor="filterNom" className="mb-1 text-md font-semibold text-gray-700">
              Nom de la personne
            </label>
            <input
              type="text"
              id="filterNom"
              placeholder="Entrez le nom"
              value={filterNom}
              onChange={(e) => setFilterNom(e.target.value)}
              className={`p-3 border rounded-xl shadow-sm focus:outline-none transition-all duration-200
                ${messageErreurNom ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-purple-500 focus:border-purple-500'}`}
              />
              {messageErreurNom && (
                <p className="mt-1 text-xs text-red-600 break-words">
                  {messageErreurNom}
                </p>
              )}
          </div>

          <div className="flex flex-col w-[14%]">
            <label htmlFor="numeroFormulaire" className="mb-1 text-md font-semibold text-gray-700">
              Numéro du Formulaire
            </label>
            <input
              type="text"
              id="numeroFormulaire"
              value={numeroFormulaire}
              onChange={(e) => setNumeroFormulaire(e.target.value)}
              placeholder="Entrez le numéro"
               className={`p-3 border rounded-xl shadow-sm focus:outline-none transition-all duration-200
                              ${messageErreur ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-purple-500 focus:border-purple-500'}`}
            />
            {messageErreur && (
              <p className="mt-1 text-xs text-red-600 break-words">
                {messageErreur}
              </p>
            )}
          </div>

          <div className="flex flex-col  w-[13%]">
  <label htmlFor="startDate" className="mb-2 text-sm font-medium text-gray-700">
    De
  </label>
  <input
    type="date"
    id="startDate"
    value={startDate}
    onChange={(e) => setStartDate(e.target.value)}
    className={`p-3 border rounded-xl shadow-sm focus:outline-none transition-all duration-200
      ${messageErreurDate ? 'border-red-500 focus:ring-red-500' : 'border-gray-300 focus:ring-purple-500 focus:border-purple-500'}`}
  />
  {messageErreurDate && (
              <p className="mt-1 text-xs text-red-600 break-words">
                {messageErreurDate}
              </p>
            )}
</div>

          <div className="flex flex-col">
            <label htmlFor="endDate" className="mb-1 text-md font-semibold text-gray-700">
              À
            </label>
            <input
              type="date"
              id="endDate"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="p-3 border border-gray-300 rounded-xl shadow-sm focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-all duration-200"
            />
          </div>

          {/* ✅ Bouton Rechercher */}
          <div className="flex items-end">
            <button
              onClick={handleSearch}
              className="bg-green-500 hover:bg-green-600 text-white font-semibold px-4 py-3 rounded-xl shadow-md transition-all duration-200"
            >
              Rechercher
            </button>
          </div>

          {/* Bouton Réinitialiser */}
          <div className="flex items-end">
            <button
              onClick={handleClearFilters}
              className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-4 py-3 rounded-xl shadow-md transition-all duration-200"
            >
              Réinitialiser
            </button>
          </div>
        </div>
      )}

      <ArchivesSchema
        formData={filteredData}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        user={user}
        authLoading={authLoading}
      />
    </div>
  );
};

export default ArchivesForms;


